import React from "react";
import AddToPlanButton from "../AddToPlanButton/AddToPlanButton";
import { chipLabelsFromItem, tileSecondaryLine } from "../../lib/cardDisplay";

function truncate(text, maxLen) {
  if (!text) return "";
  const t = String(text).trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, Math.max(0, maxLen - 1)).trimEnd()}…`;
}

export default function CardPreview({
  item,
  mode,
  columnId,
  eventId,
  onAddToSlot,
  onClick,
  onKeyDown,
  wrapperClassName = "",
  label = "",
  columnType = "event",
  planDayDates = null,
  planSlots = null,
  getSlotKey = null,
}) {
  const isStory = columnType === "story";
  const chips = chipLabelsFromItem(item, 3);
  const secondary = tileSecondaryLine(item, isStory);

  const showMeta =
    (mode === "full" || mode === "minimal") && (!!chips.length || !!secondary);

  return (
    <div
      className={`card-preview card-preview--${mode} ${wrapperClassName}`.trim()}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
    >
      {onAddToSlot && (
        <div className="card-preview-add">
          <AddToPlanButton
            columnId={columnId}
            eventId={eventId}
            onAddToSlot={onAddToSlot}
            variant="compact"
            activity={item}
            planDayDates={planDayDates}
            planSlots={planSlots}
            getSlotKey={getSlotKey}
          />
        </div>
      )}
      <div className="card-preview-content">
        <div
          className={`card-preview-media-wrap${item?.image ? " card-preview-media-wrap--has-media" : ""}`}
        >
          {item?.image ? (
            <img
              className="card-preview-image"
              src={item.image}
              alt={item?.title ?? label}
              loading="lazy"
            />
          ) : null}
        </div>
        <div className="card-preview-title">{truncate(item?.title, 60)}</div>
        {showMeta && (
          <>
            {chips.length > 0 ? (
              <div className="card-preview-chips" aria-label="Kurzinfo">
                {chips.map((text) => (
                  <span key={text} className="card-preview-chip">
                    {text}
                  </span>
                ))}
              </div>
            ) : null}
            {secondary ? (
              <div className="card-preview-meta card-preview-meta--secondary">
                {truncate(secondary, isStory ? 130 : 80)}
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
